import actions from './actions'

export default function CallCenterActivityLogsReducer(state = { loading: false, listModal: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CALLCENTERACTIVITYLOG:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.LIST_CALLCENTERACTIVITYLOG2:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }

    case actions.FETCH_CALLCENTERACTIVITYLOGS23_OPEN_RECIEVED:
      return {
        ...state,
        listModal: true,
      }
    case actions.FETCH_CALLCENTERACTIVITYLOGS23_CLOSE_RECIEVED:
      return {
        ...state,
        listModal: false,
      }

    case actions.LIST_CALLCENTERACTIVITYLOG23:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CALLCENTERACTIVITYLOG:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CALLCENTERACTIVITYLOG:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CALLCENTERACTIVITYLOG:
      return {
        ...state,
        editing: { callCenterActivityLogID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.DELETE_CALLCENTERACTIVITYLOG_RECIEVED:
      return {
        ...state,
        editing: { callCenterActivityLogID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
